import { Skeleton } from '@interco/inter-ui/components/Skeleton'

export const fulLWidth = { width: '100%' }

export const SkeletonImageBuy = () => (
  <Skeleton
    width="96px"
    height="86px"
    animation="pulse"
    style={{ minWidth: '96px', borderRadius: '8px' }}
  />
)
